module.exports = __webpack_public_path__ + "img/impactful-text.a9100d8c.svg";